export default class DadosDasReceitas {
    constructor(formulario = '') {
        this.vendaProdutosBovinoculturaCorteValorTotal = formulario.vendaProdutosBovinoculturaCorteValorTotal == undefined ? 0 : formulario.vendaProdutosBovinoculturaCorteValorTotal;
        this.receitaAluguelPastoValorTotal = formulario.receitaAluguelPastoValorTotal == undefined ? 0 : formulario.receitaAluguelPastoValorTotal;
        this.precoArrobaBoiGordo = formulario.precoArrobaBoiGordo == undefined ? 0 : formulario.precoArrobaBoiGordo;
    }
}